<template>
  <div class="changelog participations">
    <div>
      <div v-for="(lval, lkey) in log" :key="lkey">
        <span class="user">{{ user(lval.user_id) }} - {{ time(lval.created_at) }}</span>
        <table>
          <tr>
            <td style="width: 140px">{{ _.role }}: </td>
            <td>{{ role(lval.role_type, lval.role_id) }}</td>
          </tr>
          <tr>
            <td style="width: 140px">{{ _.person }}: </td>
            <td>{{ person(lval.person_id) }}</td>
          </tr>
          <tr v-if="lval.presentation">
            <td style="width: 140px">{{ _.presentation }}: </td>
            <td>{{ lval.session_presentation }} {{ lval.presentation }}</td>
          </tr>
          <tr>
            <td style="width: 140px">{{ _.state }}: </td>
            <td>{{ state(lval.state_id) }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      users: [],
      persons: [],
      roles: [],
      states: [],
      log: [],
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user(id) {
      return (this.users && this.users[id]) ? this.users[id] : 'System';
    },
    person(id) {
      return (this.persons && this.persons[id]) ? this.persons[id] : '';
    },
    role(type, id) {
      return (this.roles && this.roles[type] && this.roles[type][id]) ? this.roles[type][id] : '';
    },
    state(id) {
      return (this.states && this.states[id]) ? this._[this.states[id]] : '';
    },
  },
  async created() {
    dayjs.extend(utc);
    const log = await this.axios.get(API_URL + '/logs/' + this.$route.path.split('/')[1] + 's/' + this.$route.params.id + '/participations');
    this.users = log.data.users;
    this.persons = log.data.persons;
    this.roles = log.data.roles;
    this.states = log.data.states;
    this.log = log.data.log;
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.changelog.participations {
  position: absolute;
  top: 0;
  right: 0;
  width: 680px;
  height: 100%;
  opacity: .95;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    overflow-y: scroll;
    > div {
      padding: 12px;
      &:not(:first-child) {
        border-top: 1px solid lighten($primary-color, 80%);
      }
      > span {
        display: inline-block;
        opacity: .4;
        padding-left: 2px;
        margin-bottom: 3px;
        border-bottom: 0;
      }

    }
  }
}
</style>